import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import type { ConsentStore } from '@mfe-4cs/state/ConsentStore';
import { stripHtml } from '@mfe-4cs/util/helpers';
import { html, nothing, TemplateResult } from 'lit';

export function consentTemplateOverview(this: TefComs4csMicroFrontend, consent: ConsentStore): TemplateResult {
  const { featureTitlesAsString } = consent;
  return html`
      <div class="row">
        <div class="col">${stripHtml(consent.shortScope!)}</div>
          ${featureTitlesAsString
  /* eslint-disable @typescript-eslint/indent */
            ? html`
              <div class="col">
                <strong>${featureTitlesAsString}</strong>
              </div>`
            : nothing
          }
      </div>
  `;
}
